// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/vision-disruption-effects.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/vision-disruption-effects/vision-disruption-effects.js';

mount([g0]);
